import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import Tag from '@/views/Tag'
import Auth from '@/views/Auth'
import SignIn from '@/views/auth/SignIn'
import SignUpStart from '@/views/auth/SignUpStart'
import SignUpFix from '@/views/auth/SignUpFix'
import PasswdChange from '@/views/auth/PasswdChange'
import AttributeGet from '@/views/auth/AttributeGet'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/tag',
      name: 'Tag',
      component: Tag
    },
    // {
    //   path: '/home',
    //   name: 'HelloWorld',
    //   component: HelloWorld,
    //   beforeEnter: requireAuth
    // },
    {
      path: '/auth',
      name: 'Auth',
      component: Auth,
      children: [
        {
          path: 'signin',
          name: 'SignIn',
          component: SignIn
        },
        {
          path: 'signupstart',
          name: 'SignUpStart',
          component: SignUpStart
        },
        {
          path: 'signupfix',
          name: 'SignUpFix',
          component: SignUpFix
        },
        {
          path: 'passwdchange',
          name: 'PasswdChange',
          component: PasswdChange
        },
        {
          path: 'attributeget',
          name: 'AttributeGet',
          component: AttributeGet
        }
      ]
    }
  ]
})
